import { useMutation, useQueryClient } from "@tanstack/react-query";
import { defensaService } from "../services/defensaService";
import { PedidoDefensa } from "../types/defensa";

const DEFENSAS_KEY = ["defensas"];

/** Tras tocar una defensa cambian las tarjetas del proceso y la ficha del estudiante. */
function useRefrescar() {
  const qc = useQueryClient();
  return () => {
    qc.invalidateQueries({ queryKey: DEFENSAS_KEY });
    qc.invalidateQueries({ queryKey: ["instancias"] });
    qc.invalidateQueries({ queryKey: ["estudiante"] });
    qc.invalidateQueries({ queryKey: ["tareas"] });
  };
}

export function useAgendarDefensa() {
  const refrescar = useRefrescar();
  return useMutation({
    mutationFn: ({ id, pedido }: { id: number; pedido: PedidoDefensa }) => defensaService.agendar(id, pedido),
    // También al fallar: sin sala, la coordinación vuelve a empezar y la tarjeta tiene que verlo.
    onSettled: refrescar,
  });
}

export function useCancelarDefensa() {
  const refrescar = useRefrescar();
  return useMutation({
    mutationFn: ({ id, motivo }: { id: number; motivo: string }) => defensaService.cancelar(id, motivo),
    onSuccess: refrescar,
  });
}

export function useSincronizarMiti() {
  const refrescar = useRefrescar();
  return useMutation({ mutationFn: (id: number) => defensaService.sincronizarMiti(id), onSuccess: refrescar });
}

export function useIngresarCorreo() {
  const refrescar = useRefrescar();
  return useMutation({
    mutationFn: ({ id, clave, email }: { id: number; clave: string; email: string }) => defensaService.ingresarCorreo(id, clave, email),
    onSuccess: refrescar,
  });
}

export function useRevisarDefensa() {
  const refrescar = useRefrescar();
  return useMutation({ mutationFn: (id: number) => defensaService.revisar(id), onSuccess: refrescar });
}

export function useSubirCartaRemota() {
  const refrescar = useRefrescar();
  return useMutation({
    mutationFn: ({ id, clave, archivo }: { id: number; clave: string; archivo: File }) =>
      defensaService.subirCartaRemota(id, clave, archivo),
    onSuccess: refrescar,
  });
}

export function useAprobarCartaRemota() {
  const refrescar = useRefrescar();
  return useMutation({
    mutationFn: ({ id, clave }: { id: number; clave: string }) => defensaService.aprobarCartaRemota(id, clave),
    onSuccess: refrescar,
  });
}
